module.exports = __webpack_public_path__ + "static/media/rates-home-hippo.0889a20a.svg";